import { useState, useCallback } from "react";
import { PaymentObject } from "../../panels";
import { UsePaymentPanelReturn } from "./types";
import { PanelAction } from "../../../Transactions";

export const usePaymentPanel = (): UsePaymentPanelReturn => {
  const [panel, setPanel] = useState<{
    action: PanelAction;
    isOpen: boolean;
    payment: PaymentObject | undefined;
  }>({
    action: "edit",
    isOpen: false,
    payment: undefined,
  });

  const openPanel = useCallback(
    (action: PanelAction, payment?: PaymentObject) => {
      setPanel({
        action,
        isOpen: true,
        payment,
      });
    },
    [],
  );

  const closePanel = useCallback(() => {
    setPanel((prev) => ({ ...prev, isOpen: false, payment: undefined }));
  }, []);

  const getPanelTitle = useCallback(() => {
    switch (panel.action) {
      case "edit":
        return "Edit Payment";
      case "duplicate":
        return "Duplicate Payment";
      case "create":
      default:
        return "Create Payment";
    }
  }, [panel.action]);

  return {
    panel,
    setPanel,
    openPanel,
    closePanel,
    getPanelTitle,
  };
};
